import { render, staticRenderFns } from "./SsoCallback.vue?vue&type=template&id=1d4ee792&scoped=true"
import script from "./SsoCallback.vue?vue&type=script&lang=js"
export * from "./SsoCallback.vue?vue&type=script&lang=js"
import style0 from "./SsoCallback.vue?vue&type=style&index=0&id=1d4ee792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4ee792",
  null
  
)

export default component.exports